// src/components/shared/EmojiPicker.jsx
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { createPortal } from 'react-dom';
import Picker from '@emoji-mart/react';
import data from '@emoji-mart/data';
import '../../styles/EmojiPicker.css';

const EmojiPicker = ({ onEmojiSelect, onClose, triggerRef }) => {
  const [position, setPosition] = useState({ top: 0, left: 0 });

  useEffect(() => {
    if (triggerRef?.current) {
      const rect = triggerRef.current.getBoundingClientRect();
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const scrollLeft = window.scrollX || document.documentElement.scrollLeft;

      // Position the picker above the trigger by ~350px height
      setPosition({
        top: rect.top + scrollTop - 360, // open upward from button
        left: rect.left + scrollLeft,
      });
    }
  }, [triggerRef]);

  return createPortal(
    <div
      className="custom-emoji-picker-portal"
      style={{
        position: 'absolute',
        top: `${position.top}px`,
        left: `${position.left}px`,
        zIndex: 9999,
      }}
    >
      <Picker
        data={data}
        onEmojiSelect={onEmojiSelect}
        theme="auto"
        previewPosition="none"
        skinTonePosition="search"
        onClickOutside={onClose}
      />
    </div>,
    document.body
  );
};

EmojiPicker.propTypes = {
  onEmojiSelect: PropTypes.func.isRequired,
  onClose: PropTypes.func,
  triggerRef: PropTypes.object.isRequired,
};

export default EmojiPicker;
